import React from "react"

import {ItemModelV2_CalculatedValues} from "../../../../../model2/item2/calculated/@type"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import TasksView_Column from "../../../../../model2/column/column"
import FieldProto from "../../../../proto/field-proto"

type Props = {
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    onMouseEnter    : callback
    onMouseLeave    : callback
}

// const debug = "FieldPercentage_TableCellCalculated_NotHovered"
const debug = false

export default function FieldPercentage_TableCellCalculated_NotHovered(props: Props) {

    const classes = Classes("cell-flex ui5-field-editable size-small ui5-txt-less-important-small", props.column.id, {
        // 'is-expanded-calculated': props.listItem.isGroup && !props.listItem.view.isCollapsed
    })

    const showSummaryView   = /*props.listItem.isGroup ||*/ props.listItem.view.isCollapsed
    let notHoveredContent   = null
    let showSummary         = false

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]

    debug && console.log(debug, "renderNotHovered", showSummaryView, calculatedValues)

    if (showSummaryView && !!calculatedValues?.children.value && calculatedValues.total.value != calculatedValues.own) {
        notHoveredContent = calculatedValues.total.value
        showSummary = true
    } else if (calculatedValues?.own) {
        notHoveredContent = calculatedValues.own
    } else {
        notHoveredContent = props.field.getViewValue(props.listItem.item)
    }

    const showSymbol = !!notHoveredContent

    return (
        <div className      = {classes}
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            {showSummary &&
                <div className="ui5-ico-12 i5-summary-symbol m-r-5 m-t-1"/>}

            {notHoveredContent}

            {showSymbol &&
                <div className="symbol m-l-5">%</div>}
        </div>
    )
}
